import type { TCsvType } from 'App/data-export/components/_utils/createAndDownloadCsvIfApplicable/createCsv'
import type {
  TCsvHeaderMap,
  TCsvRowMap,
  TFieldAssetItem,
  TRenderValuesAndLabels,
} from 'App/data-export/types/types'
import moment from 'moment-timezone'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import { getCropNameFromId } from 'utils/getCropNameFromId'

export const populateHeaderAndRowMaps = <TValue, TMetadata>(args: {
  csvHeaderMap: TCsvHeaderMap
  csvRowMap: TCsvRowMap
  csvType: TCsvType
  dateFormat: 'YYYY-MM-DDTHH:mm:ssZ' | 'YYYY-MM-DD'
  fieldAssetItem: TFieldAssetItem
  items: Array<{ metadata: TMetadata; timeseries: Array<{ timestamp: string; value: TValue }> }>
  renderValuesAndLabels: TRenderValuesAndLabels<TValue, TMetadata>
  vt: string
}) => {
  const getRow = (key: string) => {
    let row = args.csvRowMap.get(key)

    if (!row) {
      row = new Map<string, string>()

      args.csvRowMap.set(key, row)
    }

    return row
  }

  let cropName = null

  if (args.csvType === 'blocks') {
    const propertyId = Number(args.fieldAssetItem.propertyId)
    const blockId = Number(args.fieldAssetItem.id)
    const property = fieldAssetStore.getState().properties?.[propertyId]
    const cropId = property?.blocks?.[blockId]?.cropIds?.[0]

    cropName = getCropNameFromId(cropId)
  }

  args.items.forEach((item) => {
    const valueRenderers = args.renderValuesAndLabels({
      metadata: item.metadata,
      valueType: args.vt,
      fieldAssetItem: args.fieldAssetItem,
    })

    item.timeseries.forEach((ts) => {
      const row = getRow(`${args.fieldAssetItem.id}_${ts.timestamp}`)

      row.set('fieldAssetItem.propertyName', args.fieldAssetItem.propertyName)

      row.set('fieldAssetItem.name', args.fieldAssetItem.name)

      const timestamp = moment.tz(ts.timestamp, args.fieldAssetItem.propertyTimezone).format(args.dateFormat)

      row.set('timestamp', timestamp)

      if (cropName) {
        row.set('cropName', cropName)
      }

      valueRenderers(ts.value).forEach((v) => {
        const colValKey = `${args.vt}.${v.id}`

        row.set(colValKey, v.value)

        if (!args.csvHeaderMap.has(colValKey)) {
          args.csvHeaderMap.set(colValKey, v.label)
        }
      })
    })
  })
}
